(function () {
  const MOQ_RULES = {
    "44164604559633": 2,
    "44164601413905": 2,
    "44164598235409": 2,
    "44164597547281": 2,
    "46979039985937": 2,
  };

  function getMinForVariant(variantId) {
    return MOQ_RULES[String(variantId)] || 1;
  }

  // ---------- Product page / sticky bar / quick-view popup: reset qty on variant switch ----------
  const lastVariantByForm = new WeakMap();
  const wiredForms = new WeakSet();

  function wireQuantityClamp(form, qtyInput) {
    if (wiredForms.has(form)) return;
    wiredForms.add(form);
    qtyInput.addEventListener('change', () => {
      const min = parseInt(qtyInput.min, 10) || 1;
      if (parseInt(qtyInput.value, 10) < min) qtyInput.value = min;
    });
  }

  function applyMoqToForm(form) {
    const idField = form.querySelector('input[name="id"], select[name="id"]');
    const qtyInput = form.querySelector('input[name="quantity"]');
    if (!idField || !qtyInput) return;

    wireQuantityClamp(form, qtyInput);

    const currentId = idField.value;
    const previousId = lastVariantByForm.get(form);

    if (currentId !== previousId) {
      const min = getMinForVariant(currentId);
      qtyInput.min = min;
      qtyInput.value = min;
      lastVariantByForm.set(form, currentId);
    }
  }

  function scanAndApplyProductForms() {
    const forms = new Set();
    document.querySelectorAll('input[name="quantity"]').forEach((qtyInput) => {
      const form = qtyInput.closest('form');
      if (form) forms.add(form);
    });
    forms.forEach(applyMoqToForm);
  }

  // ---------- THE FIX: block "Add to cart" itself if qty is below the minimum ----------
  document.addEventListener(
    'click',
    function (e) {
      const submitControl = e.target.closest(
        'button[type="submit"], input[type="submit"], button[name="add"], input[name="add"]'
      );
      if (!submitControl) return;

      const form = submitControl.closest('form');
      if (!form) return;

      const idField = form.querySelector('input[name="id"], select[name="id"]');
      if (!idField) return;

      const qtyInput = form.querySelector('input[name="quantity"]');
      const variantId = idField.value;
      const min = getMinForVariant(variantId);
      const qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      if (qty < min) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        window.alert('Min. order quantity is ' + min);
        if (qtyInput) qtyInput.value = min; // pre-fix it so their next click succeeds
      }
    },
    true // capture phase — runs before the theme's own add-to-cart handler, and blocking
         // the click here prevents the form from ever submitting
  );

  // ---------- Cart page: block "-" button and typed values below minimum ----------
  function getVariantIdFromLineDataId(dataId) {
    return dataId ? dataId.split(':')[0] : null;
  }

  document.addEventListener(
    'click',
    function (e) {
      const btn = e.target.closest('[data-qty-change="dec"]');
      if (!btn) return;

      const dataId = btn.dataset.id;
      const min = getMinForVariant(getVariantIdFromLineDataId(dataId));
      if (min <= 1) return;

      const qtyInput = document.querySelector(
        `.scd-item__qty_input[data-id="${CSS.escape(dataId)}"]`
      );
      if (!qtyInput) return;

      if (parseInt(qtyInput.value, 10) <= min) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    },
    true
  );

  document.addEventListener('change', function (e) {
    const qtyInput = e.target.closest('.scd-item__qty_input');
    if (!qtyInput) return;

    const min = getMinForVariant(getVariantIdFromLineDataId(qtyInput.dataset.id));
    if (parseInt(qtyInput.value, 10) < min) {
      qtyInput.value = min;
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  // ---------- Boot ----------
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanAndApplyProductForms);
  } else {
    scanAndApplyProductForms();
  }
  setInterval(scanAndApplyProductForms, 300);
})();